import React, { useState } from "react";
import { Info, CheckCircle, AlertTriangle, XCircle, X } from "lucide-react";
import { cx } from "./cx";

// Alert — inline banner. tone: info|success|warning|danger. title?, children,
// dismissible? (renders a close button that hides the alert locally).
//
// REFINEMENT NOTES: dismiss button upgraded to focus-visible + optical -mr-1.
// Tones unchanged (warning intentionally uses the amber accent token).
const TONES = {
  info: { wrap: "bg-info-50 border-info/30 text-info", Icon: Info },
  success: { wrap: "bg-success-50 border-success/30 text-success", Icon: CheckCircle },
  warning: { wrap: "bg-accent/10 border-accent/40 text-primary", Icon: AlertTriangle },
  danger: { wrap: "bg-danger-50 border-danger/30 text-danger", Icon: XCircle },
};

export function Alert({ tone = "info", title, children, dismissible = false, className = "" }) {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  const { wrap, Icon } = TONES[tone] || TONES.info;
  return (
    <div
      role="alert"
      className={cx("flex items-start gap-3 rounded-card border px-4 py-3 text-sm", wrap, className)}
    >
      <Icon size={18} className="mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        {title && <div className="font-semibold">{title}</div>}
        {children && <div className={cx("text-body", title && "mt-0.5")}>{children}</div>}
      </div>
      {dismissible && (
        <button
          onClick={() => setOpen(false)}
          aria-label="Dismiss"
          className="shrink-0 -mr-1 rounded-btn p-0.5 opacity-70 transition hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
